import { render, staticRenderFns } from "./DdsDiscardFirst.vue?vue&type=template&id=cc67be16&scoped=true&"
import script from "./DdsDiscardFirst.vue?vue&type=script&lang=js&"
export * from "./DdsDiscardFirst.vue?vue&type=script&lang=js&"
import style0 from "./DdsDiscardFirst.vue?vue&type=style&index=0&id=cc67be16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc67be16",
  null
  
)

export default component.exports